module.exports = __webpack_public_path__ + "static/media/truck-monster.03094b63.svg";